export default __webpack_public_path__ + "static/media/increase-clinical-interaction-icon.24f574ba.svg";